import { useMemo } from 'react';
import { uid } from 'react-uid';

export function useId(prefix: string, providedId?: string): string {
  return useMemo(
    () => (providedId ? providedId : `${prefix}-${uid({ id: prefix })}`),
    [prefix, providedId]
  );
}
